// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const MaintenancePlanPlanNamesCriteria = props =>
    <div className='maintenance-plan-plan-names-criteria'>
        <OptionsDropDown
            className='plan-names-criteria'
            isPlaceholderTranslated={false}
            label='PLAN_NAMES'
            onChange={props.onHandlePlanNamesSelectChange}
            optionDisplayAttributes={['key', 'value']}
            optionKey='key'
            options={props.planNames}
            placeholder='SELECT_PLAN_NAMES'
            selectedValue={props.planName}
        />
    </div>;

MaintenancePlanPlanNamesCriteria.displayName = 'MaintenancePlanPlanNamesCriteria';
MaintenancePlanPlanNamesCriteria.propTypes = {
    onHandlePlanNamesSelectChange: PropTypes.func.isRequired,
    planName: PropTypes.string.isRequired,
    planNames: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default MaintenancePlanPlanNamesCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-plan-names-criteria.js